(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4345],{

/***/ 1822:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/governance",
      function () {
        return __webpack_require__(42090);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ty": function() { return /* binding */ DashboardIntervalValues; },
/* harmony export */   "f_": function() { return /* binding */ useDashboardStats; },
/* harmony export */   "wc": function() { return /* binding */ QueryKeyDashboard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20414);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50815);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95915);
/* harmony import */ var _useSession__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87627);








var DashboardIntervalValues = [
    "Week",
    "Month",
    "Year",
    "All"
];
var QueryKeyDashboard = "dashboard-stats";
var useDashboardStats = function(interval) {
    var network = (0,_useSession__WEBPACK_IMPORTED_MODULE_1__/* .useSession */ .k)().network;
    var res = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        QueryKeyDashboard,
        network.networkId,
        interval
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var selectedInterval, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    selectedInterval = interval.toLowerCase();
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("/api/data-dashboard?interval=" + selectedInterval)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    }), (0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .queryOptions */ .C)(false, true));
    var _data;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, res), {
        data: (_data = res.data) !== null && _data !== void 0 ? _data : []
    });
};


/***/ }),

/***/ 42090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ governance; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/v2/components/ui/buttons/buttonWithIcon/index.tsx + 3 modules
var buttonWithIcon = __webpack_require__(52787);
// EXTERNAL MODULE: ./src/v2/components/ui/icons/assets/index.tsx
var assets = __webpack_require__(66023);
// EXTERNAL MODULE: ./src/components/theme/styles/colors.tsx
var colors = __webpack_require__(16381);
// EXTERNAL MODULE: ./src/components/theme/styles/mixins.tsx
var mixins = __webpack_require__(52230);
// EXTERNAL MODULE: ./src/config/types.ts
var types = __webpack_require__(87859);
// EXTERNAL MODULE: ./src/v2/components/layout/statistics/graphs/tvlAreaGraph/index.tsx + 1 modules
var tvlAreaGraph = __webpack_require__(15972);
// EXTERNAL MODULE: ./src/v2/components/layout/website/SlideWrapper.tsx
var SlideWrapper = __webpack_require__(47697);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/governance/FeeGeneratedSlide.tsx
/* eslint-disable react/no-unknown-property */ 









function FeesGeneratedSlide() {
    //need to get fees
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            children: "How much fee has Vesta generated so far?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            color: colors/* primaryColors.100 */.w2[100],
                            children: "Fees from the Vesta Reference Rate"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(tvlAreaGraph/* TvlAreaGraph */.K, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    color: colors/* primaryColors.400 */.w2[400],
                    children: "Vesta also has other fees such as mint fee (deprecated) and redemption fee (deprecated), ETH fee from GLP, esGMX from GMX and GLP)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: mixins/* secondaryBox */.J0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: {
                            xs: "column",
                            sm: "row"
                        },
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 4,
                                direction: {
                                    xs: "column",
                                    sm: "row"
                                },
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* AssetIcon */.Y, {
                                        size: 42,
                                        noBg: true,
                                        noBorder: true,
                                        asset: types/* ENativeAsset.VSTA */.tx.VSTA
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        textAlign: "left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h6",
                                                color: colors/* primaryColors.100 */.w2[100],
                                                children: "Learn more about the Saving Module"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body2",
                                                color: colors/* primaryColors.400 */.w2[400],
                                                children: "and our Fee Schedule"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: {
                                    xs: "column",
                                    sm: "row"
                                },
                                spacing: 4,
                                mt: {
                                    xs: 4,
                                    sm: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        variant: "secondary",
                                        sx: {
                                            width: {
                                                xs: "100%",
                                                sm: 170
                                            }
                                        },
                                        iconType: "asterisk",
                                        children: "SAVING MODULE"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        variant: "secondary",
                                        sx: {
                                            width: {
                                                xs: "100%",
                                                sm: 240
                                            }
                                        },
                                        iconType: "asterisk",
                                        children: "CURRENT FEE SCHEDULE"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var FeeGeneratedSlide = (FeesGeneratedSlide);

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./src/v2/components/ui/images/index.tsx + 1 modules
var ui_images = __webpack_require__(24639);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/governance/GovernanceLandingSlide.tsx
/* eslint-disable react/no-unknown-property */ 





function GovernanceLandingSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden",
            pt: 32
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            direction: {
                xs: "column-reverse",
                sm: "row"
            },
            justifyContent: "start",
            textAlign: "left",
            alignItems: "center",
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 7,
                    pr: 2,
                    textAlign: {
                        xs: "center",
                        sm: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h2",
                            mt: 4,
                            children: "Transparency & Decentralization"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            mt: 4,
                            mb: 8,
                            color: colors/* primaryColors.400 */.w2[400],
                            children: "At Vesta, we strive for transparency by clearly displaying all fees within the application and providing detailed explanations in our documentation."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    textAlign: "center",
                    item: true,
                    xs: 12,
                    sm: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* Wormhole */.Df, {})
                })
            ]
        })
    });
}
/* harmony default export */ var governance_GovernanceLandingSlide = (GovernanceLandingSlide);

// EXTERNAL MODULE: ./src/v2/components/layout/website/roadmap/panel/index.tsx
var panel = __webpack_require__(65242);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/governance/ParticipateGovernanceSlide.tsx
/* eslint-disable react/no-unknown-property */ 







function ParticipateGovernanceSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h4",
                mt: 4,
                children: "Participate in Vesta‘s Governance"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                mt: 4,
                mb: 8,
                color: colors/* primaryColors.400 */.w2[400],
                children: "Play your part in Vesta's growth by participating in Vesta's governance."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                direction: {
                    xs: "column-reverse",
                    sm: "row"
                },
                justifyContent: "start",
                textAlign: "left",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        pr: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    color: colors/* primaryColors.400 */.w2[400],
                                    children: "Our Process"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* ProcessPanel */.sC, {
                                    highlight: "completed",
                                    stepTitle: "STEP A - REQUEST FOR COMMENT",
                                    description: "Voice your opinion on our governance forum: Curia",
                                    duration: 7,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        sx: {
                                            width: 240
                                        },
                                        variant: "secondary",
                                        iconType: "asterisk",
                                        children: [
                                            " ",
                                            "VISIT VESTA CURIA"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* ProcessPanel */.sC, {
                                    highlight: "upcoming",
                                    stepTitle: "STEP B - VOTING VIA SNAPSHOT",
                                    description: "Vote using VSTA: Vesta's governance token",
                                    duration: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        sx: {
                                            width: 240
                                        },
                                        variant: "secondary",
                                        iconType: "asterisk",
                                        children: "VISIT SNAPSHOT"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* ProcessPanel */.sC, {
                                    highlight: "current",
                                    stepTitle: "STEP C - EXECUTION",
                                    description: "Execution by the DAO",
                                    duration: "Varies"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        textAlign: "center",
                        xs: 12,
                        sm: 6,
                        mb: {
                            xs: 4,
                            sm: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* GovernanceConstellation */.dh, {})
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var governance_ParticipateGovernanceSlide = (ParticipateGovernanceSlide);

;// CONCATENATED MODULE: ./src/v2/components/layout/website/governance/SafetyFirstSlide.tsx







var SLIDE_BG = "linear-gradient(278.18deg, rgba(124, 79, 219, 0.8) -7.61%, rgba(0, 251, 234, 0.5) 39.1%, #B5EDFF 83.03%), #FFFFFF";
function SafetyFirstSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper/* default */.Z, {
        sx: {
            background: SLIDE_BG,
            textAlign: "center",
            justifyContent: "space-around",
            py: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            sx: {
                alignItems: "center",
                justifyContent: "center"
            },
            spacing: 6,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h6",
                    color: colors/* primaryColors.900 */.w2[900],
                    children: "Safety First!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h6",
                    color: colors/* primaryColors.900 */.w2[900],
                    children: "The code of our protocol has been verified by external professionals."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    direction: {
                        xs: "column",
                        md: "row"
                    },
                    spacing: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                        iconType: "asterisk",
                        sx: {
                            color: "black",
                            borderColor: "black",
                            width: 260
                        },
                        variant: "secondary",
                        children: "CHECK THE VERILOG AUDIT"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: {
                        xs: "column",
                        sm: "row"
                    },
                    spacing: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    color: colors/* primaryColors.900 */.w2[900],
                                    children: "Audited by"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* VerilogLogoV2 */.H2, {
                                    background: colors/* primaryColors.900 */.w2[900]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    color: colors/* primaryColors.900 */.w2[900],
                                    children: "Secured by"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* ImmuneFiLogoV2 */.k$, {
                                    background: colors/* primaryColors.900 */.w2[900]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var governance_SafetyFirstSlide = (SafetyFirstSlide);

// EXTERNAL MODULE: ./src/v2/components/layout/website/LandingFooter.tsx
var LandingFooter = __webpack_require__(28424);
// EXTERNAL MODULE: ./src/v2/components/ui/containers/fade/index.tsx
var fade = __webpack_require__(41394);
;// CONCATENATED MODULE: ./src/pages/governance.tsx









var GovernancePage = function() {
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setVisible(true);
        }, 1);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(fade/* FadeContainer */.B, {
                visible: visible ? 1 : 0,
                time: 0.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(governance_GovernanceLandingSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(governance_SafetyFirstSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeGeneratedSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(governance_ParticipateGovernanceSlide, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var governance = (GovernancePage);


/***/ }),

/***/ 63049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qn": function() { return /* binding */ SECONDS_IN_A_YEAR; },
/* harmony export */   "Xc": function() { return /* binding */ getTimestampAtStartOfNextHour; },
/* harmony export */   "YA": function() { return /* binding */ getTimestampAtStartOfNextDay; },
/* harmony export */   "bf": function() { return /* binding */ UNIX_DAY; },
/* harmony export */   "bp": function() { return /* binding */ calculateRemainingTime; },
/* harmony export */   "em": function() { return /* binding */ getDifferenceInMonths; },
/* harmony export */   "gJ": function() { return /* binding */ getTimestampAtStartOfNextWeek; },
/* harmony export */   "mR": function() { return /* binding */ getTimestampAtStartOfNextMonth; },
/* harmony export */   "nb": function() { return /* binding */ getTimestampAtStartOfDayUTC; }
/* harmony export */ });
/* unused harmony exports SECONDS_PER_MIN, getTimestampAtStartOfMonth */
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

var getTimestampAtStartOfDayUTC = function(timestamp) {
    var date = new Date(timestamp * 1000);
    var date_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    var startOfDay = Number(new Date(date_utc));
    var endTimestamp = startOfDay / 1000;
    return Math.floor(endTimestamp / 86400) * 86400;
};
var UNIX_DAY = 86400;
var SECONDS_PER_MIN = 60;
var SECONDS_IN_A_YEAR = 31536000;
var getTimestampAtStartOfMonth = function(timestamp) {
    var date = new Date(timestamp);
    var firstDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1);
    return firstDay.valueOf();
};
var getTimestampAtStartOfNextMonth = function(timestamp) {
    var date = new Date(timestamp);
    var firstDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1);
    return firstDay.valueOf();
};
var getTimestampAtStartOfNextWeek = function(timestamp) {
    var date = new Date(timestamp);
    var firstDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + 7);
    return firstDay.valueOf();
};
var getTimestampAtStartOfNextDay = function(timestamp) {
    var interval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var date = new Date(timestamp);
    var firstDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + 1 * interval);
    return firstDay.valueOf();
};
var getTimestampAtStartOfNextHour = function(timestamp) {
    var interval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var date = new Date(timestamp);
    var firstDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours() + 1 * interval);
    return firstDay.valueOf();
};
var getDifferenceInMonths = function(timestampStart, timestampEnd) {
    var dateTo = new Date(timestampEnd);
    var dateFrom = new Date(timestampStart);
    return dateTo.getMonth() - dateFrom.getMonth() + 12 * (dateTo.getFullYear() - dateFrom.getFullYear());
};
var calculateRemainingTime = function(endingTimestamp) {
    var now = moment__WEBPACK_IMPORTED_MODULE_0___default()(new Date());
    var remainingTime = moment__WEBPACK_IMPORTED_MODULE_0___default().duration(moment__WEBPACK_IMPORTED_MODULE_0___default()(endingTimestamp * 1000).diff(now));
    var remainingDays = remainingTime.asDays() < 0 ? 0 : Math.floor(remainingTime.asDays());
    var remainingHours = remainingTime.hours() < 0 ? 0 : remainingTime.hours();
    var remainingMins = remainingTime.minutes() < 0 ? 0 : remainingTime.minutes();
    return "".concat(remainingDays, "D ").concat(remainingHours, "H ").concat(remainingMins, "M");
};


/***/ }),

/***/ 79455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qN": function() { return /* binding */ createTimeTicks; }
/* harmony export */ });
/* unused harmony exports getTimeDomain, getTicks, getTickFormatter */
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63049);


var TIME_DATA_KEY = "timestamp";
var TIME_INTERVAL = 0;
var TIME_HOURLY_FORMAT = "H:mm";
var TIME_DAILY_FORMAT = "D MMM";
var TIME_MONTHLY_FORMAT = "MMM";
var getTimeDomain = function(graphData) {
    return [
        graphData[0].timestamp,
        graphData[graphData.length - 1].timestamp
    ];
};
var getTicks = function(param) {
    var graphData = param.graphData, tickCount = param.tickCount, getNextTick = param.getNextTick;
    return new Array(tickCount).fill(0).reduce(function(acc, _, index) {
        if (index === 0) {
            acc.push(graphData[0].timestamp);
        } else {
            acc.push(getNextTick(acc[index - 1]));
        }
        return acc;
    }, []);
};
var getTickFormatter = function(format) {
    return function(val) {
        return moment__WEBPACK_IMPORTED_MODULE_0___default()(val).utc().format(format);
    };
};
var createTimeTicks = function(graphData, interval) {
    var tickCount = 0;
    var domain = getTimeDomain(graphData);
    var getNextTick = _utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getTimestampAtStartOfNextDay */ .YA;
    var tickFormat = TIME_DAILY_FORMAT;
    switch(interval){
        case "Day":
            {
                tickCount = 7;
                getNextTick = function(timestamp) {
                    return (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getTimestampAtStartOfNextHour */ .Xc)(timestamp, 4);
                };
                tickFormat = TIME_HOURLY_FORMAT;
                break;
            }
        case "Week":
            {
                tickCount = 7;
                getNextTick = function(timestamp) {
                    return (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getTimestampAtStartOfNextDay */ .YA)(timestamp, 1);
                };
                tickFormat = TIME_DAILY_FORMAT;
                break;
            }
        case "Month":
            {
                tickCount = 5;
                getNextTick = _utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getTimestampAtStartOfNextWeek */ .gJ;
                tickFormat = TIME_DAILY_FORMAT;
                break;
            }
        case "Year":
            {
                var monthDiff = (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getDifferenceInMonths */ .em)(domain[0], domain[1]) + 1;
                if (monthDiff < 13) {
                    tickCount = (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getDifferenceInMonths */ .em)(domain[0], domain[1]) + 1;
                } else {
                    tickCount = 13;
                }
                getNextTick = _utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getTimestampAtStartOfNextMonth */ .mR;
                tickFormat = TIME_MONTHLY_FORMAT;
                break;
            }
        case "All":
            {
                tickCount = (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getDifferenceInMonths */ .em)(domain[0], domain[1]) + 1;
                getNextTick = _utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getTimestampAtStartOfNextMonth */ .mR;
                tickFormat = TIME_MONTHLY_FORMAT;
                break;
            }
    }
    var ticks = getTicks({
        graphData: graphData,
        tickCount: tickCount,
        getNextTick: getNextTick
    });
    var tickFormatter = getTickFormatter(tickFormat);
    return {
        ticks: ticks,
        tickFormatter: tickFormatter,
        dataKey: TIME_DATA_KEY,
        domain: domain,
        interval: TIME_INTERVAL
    };
};


/***/ }),

/***/ 9095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ GraphToolTip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67720);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16381);
/* harmony import */ var _components_theme_styles_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52230);







var GraphToolTip = function(param) {
    var _timeFormat = param.timeFormat, timeFormat = _timeFormat === void 0 ? "MMMM Do YYYY h:mm" : _timeFormat, active = param.active, payload = param.payload, children = param.children;
    if (active && payload && payload.length) {
        var timestamp = payload[0].payload.timestamp;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
            sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                padding: "24px"
            }, _components_theme_styles_mixins__WEBPACK_IMPORTED_MODULE_3__/* .defaultBackground */ .zY, (0,_components_theme_styles_mixins__WEBPACK_IMPORTED_MODULE_3__/* .columnGap */ .e$)(16)), {
                width: "280px",
                backdropFilter: "blur(12.5px)"
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    sx: {
                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[400] */ .w2[400]
                    },
                    variant: "label3",
                    children: moment__WEBPACK_IMPORTED_MODULE_1___default()(timestamp).utc().format(timeFormat)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    sx: {
                        margin: 0
                    }
                }),
                children
            ]
        });
    }
    return null;
};


/***/ }),

/***/ 44641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ GridWrapper; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86886);

var GridWrapper = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    ".recharts-wrapper .recharts-cartesian-grid-horizontal line:first-of-type, .recharts-wrapper .recharts-cartesian-grid-horizontal line:last-child, .recharts-wrapper .recharts-cartesian-grid-vertical line:last-child, .recharts-wrapper .recharts-cartesian-grid-vertical line:first-of-type": {
        strokeOpacity: 0
    }
});


/***/ }),

/***/ 15972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ TvlAreaGraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(9253);
// EXTERNAL MODULE: ./node_modules/recharts/es6/chart/AreaChart.js
var AreaChart = __webpack_require__(46888);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/CartesianGrid.js
var CartesianGrid = __webpack_require__(14195);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(3023);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(75358);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/Area.js
var Area = __webpack_require__(86108);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(14888);
// EXTERNAL MODULE: ./src/v2/components/ui/loadSkeleton/index.tsx
var loadSkeleton = __webpack_require__(66820);
// EXTERNAL MODULE: ./src/components/hooks/dashboard/useDashboardStats.ts
var useDashboardStats = __webpack_require__(18778);
// EXTERNAL MODULE: ./src/components/theme/styles/colors.tsx
var colors = __webpack_require__(16381);
// EXTERNAL MODULE: ./src/components/theme/typography.ts
var typography = __webpack_require__(62157);
// EXTERNAL MODULE: ./src/components/types.ts
var types = __webpack_require__(87493);
// EXTERNAL MODULE: ./src/components/utils/utils.tsx
var utils = __webpack_require__(63189);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(63049);
// EXTERNAL MODULE: ./src/utils/graphs/index.tsx
var graphs = __webpack_require__(79455);
// EXTERNAL MODULE: ./src/v2/components/layout/statistics/graphs/gridWrapper.tsx
var gridWrapper = __webpack_require__(44641);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/v2/components/ui/label/index.tsx
var label = __webpack_require__(45306);
// EXTERNAL MODULE: ./src/v2/components/layout/statistics/graphs/graphToolTip.tsx
var graphToolTip = __webpack_require__(9095);
;// CONCATENATED MODULE: ./src/v2/components/layout/statistics/graphs/tvlAreaGraph/tvlAreaGraphTooltip.tsx







var TvlAreaGraphTooltip = function(param) {
    var active = param.active, payload = param.payload;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(graphToolTip/* GraphToolTip */.u, {
        active: active,
        payload: payload,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "label3",
                    color: colors/* primaryColors.700 */.w2[700],
                    children: "VESTA TVL"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                    labelTitle: (0,utils/* displayFormatUnits */.Hz)({
                        value: payload === null || payload === void 0 ? void 0 : (ref = payload[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.payload) === null || ref1 === void 0 ? void 0 : ref1.tvl,
                        displayType: types/* EDisplayType.USD */.co.USD
                    }),
                    sx: {
                        width: "fit-content"
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/v2/components/layout/statistics/graphs/tvlAreaGraph/index.tsx

















var TVL_AREA_GRAPH_INTERVAL = "Year";
var TvlAreaGraph = function() {
    var ref = (0,useDashboardStats/* useDashboardStats */.f_)(TVL_AREA_GRAPH_INTERVAL), dashboardData = ref.data, isDashboardLoading = ref.isLoading;
    var totalTvlData = (0,react.useMemo)(function() {
        return lodash_default().sortBy(dashboardData, function(param) {
            var timestamp = param.timestamp;
            return moment_default()(timestamp).valueOf();
        }).map(function(param) {
            var timestamp = param.timestamp, _stats = param.stats, tvlUsd = _stats.tvl.tvlUsd;
            return {
                timestamp: (0,date/* getTimestampAtStartOfDayUTC */.nb)(new Date(timestamp).valueOf() / 1000) * 1000,
                tvl: Number(tvlUsd)
            };
        });
    }, [
        JSON.stringify(dashboardData)
    ]);
    if (isDashboardLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loadSkeleton/* LoadSkeleton */.n, {
            isLoading: isDashboardLoading,
            width: 1088,
            height: 400
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(gridWrapper/* GridWrapper */.z, {
        sx: {
            height: "400px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AreaChart/* AreaChart */.T, {
                width: 1088,
                height: 400,
                data: totalTvlData,
                margin: {
                    top: 10,
                    right: 8,
                    left: -22,
                    bottom: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "colorTvl",
                            x1: "0",
                            y1: "0",
                            x2: "0",
                            y2: "1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0%",
                                    stopColor: "rgba(124, 79, 219, 0.8)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "50%",
                                    stopColor: "rgba(0, 251, 234, 0.5)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "100%",
                                    stopColor: "#B5EDFF"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                        strokeDasharray: "3 3",
                        color: colors/* primaryColors.900 */.w2[900]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, (0,_object_spread/* default */.Z)({
                        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typography/* label3 */.dM), {
                            fill: colors/* primaryColors.400 */.w2[400]
                        }),
                        type: "number",
                        axisLine: false
                    }, (0,graphs/* createTimeTicks */.qN)(totalTvlData, TVL_AREA_GRAPH_INTERVAL))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typography/* label3 */.dM), {
                            fill: colors/* primaryColors.400 */.w2[400]
                        }),
                        axisLine: false,
                        tickFormatter: function(val) {
                            return (0,utils/* displayFormatUnits */.Hz)({
                                value: parseFloat(val),
                                displayType: types/* EDisplayType.ShortVST */.co.ShortVST,
                                decimal: 0
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Area/* Area */.u, {
                        type: "monotone",
                        dataKey: "tvl",
                        stroke: "url(#colorTvl)",
                        fill: colors/* black.45% */.Sn["45%"],
                        strokeWidth: 2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(TvlAreaGraphTooltip, {})
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 28424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86886);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27842);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44206);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88433);
/* harmony import */ var _components_shared_divider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38359);
/* harmony import */ var _components_shared_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67113);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16381);







var FooterLink = function(param) {
    var href = param.href, title = param.title, icon = param.icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_3__/* .NormalLink */ .Yk, {
        href: href,
        sx: {
            textDecoration: "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 2,
            alignItems: "center",
            children: [
                icon ? icon : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "body3",
                    color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[700] */ .w2[700],
                    sx: {
                        transition: "color 0.15s linear",
                        ": hover": {
                            color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[400] */ .w2[400]
                        }
                    },
                    children: title
                })
            ]
        })
    });
};
var FooterLinkList = function(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        spacing: 3,
        textAlign: "left",
        mt: 8,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                mb: 1,
                variant: "base",
                children: title
            }),
            children
        ]
    });
};
var LandingFooter = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        mb: 2,
        sx: {
            px: {
                xs: "32px",
                md: "144px"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            container: true,
            justifyContent: "center",
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "About",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "About Vesta",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Trust & Transparency",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Roadmap",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Learn",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Vesta Stable",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Tutorial",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Governance",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Curia Forum",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Vote on Snapshot",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Developers",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Documentation",
                                href: "https://docs.vestafinance.xyz/"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Github",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLinkList, {
                        title: "Join Us",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                            title: "Careers",
                            href: "https://vesta-finance.notion.site/Open-Roles-on-the-Core-Team-40ce0831db6642b28bdc94d3521372a9"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Community",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Twitter",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                                href: "https://twitter.com/vestafinance"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Medium",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                                href: "https://medium.com/@VestaFinance"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Discord",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                                href: "https://discord.gg/yKsr6PRtxK"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    mt: 4,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_divider__WEBPACK_IMPORTED_MODULE_2__/* .NormalDivider */ .k4, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            direction: {
                                xs: "column",
                                sm: "row"
                            },
                            mb: 4,
                            mt: 4,
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    direction: "row",
                                    spacing: 4,
                                    justifyContent: "start",
                                    width: "100%",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            variant: "label3",
                                            color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[700] */ .w2[700],
                                            children: "PROUD CREATION OF MAXIMUS LABS"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_3__/* .NormalLink */ .Yk, {
                                            sx: {
                                                textDecoration: "none"
                                            },
                                            href: "https://docs.google.com/document/d/e/2PACX-1vR35fS4nqisK3TMMmULwrZBqRu-ujqShbrZU_3KeqU51yGWe_lQtqCFAoIC1Lg5f67n4mDKYbsbZ093/pub",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                sx: {
                                                    transition: "color 0.15s linear",
                                                    ": hover": {
                                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[400] */ .w2[400]
                                                    }
                                                },
                                                variant: "label3",
                                                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[900] */ .w2[900],
                                                children: "TERMS OF SERVICE"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_3__/* .NormalLink */ .Yk, {
                                            href: "https://docs.google.com/document/d/e/2PACX-1vRAewaErhuxxT6Hxss_3IWNVw3-PlByipiDIXYwNhfVF0EDEp0CGbBPSjSzN9JHbmafM5BtU0KOf0w0/pub",
                                            sx: {
                                                textDecoration: "none"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                sx: {
                                                    transition: "color 0.15s linear",
                                                    ": hover": {
                                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[400] */ .w2[400]
                                                    }
                                                },
                                                variant: "label3",
                                                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[900] */ .w2[900],
                                                children: "PRIVACY POLICY"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    variant: "h6",
                                    sx: {
                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .white["15%"] */ .ix["15%"],
                                        display: "flex",
                                        gap: "1em",
                                        justifyContent: "space-around",
                                        textAlign: "center",
                                        mt: {
                                            xs: 4,
                                            sm: 0
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "V"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "E"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "S"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "T"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "A"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingFooter);


/***/ }),

/***/ 47697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99226);




var SlideWrapper = function(param) {
    var children = param.children, sx = param.sx, onMouseMove = param.onMouseMove;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onMouseMove: onMouseMove,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            backgroundSize: "cover",
            px: {
                xs: "32px",
                md: "144px"
            },
            height: "100%",
            mb: 40
        }, sx),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SlideWrapper);


/***/ }),

/***/ 65242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pt": function() { return /* binding */ VerticalRoadmapPanel; },
/* harmony export */   "sC": function() { return /* binding */ ProcessPanel; },
/* harmony export */   "wC": function() { return /* binding */ RoadmapPanel; }
/* harmony export */ });
/* unused harmony export HorizontalRoadmapStep */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16381);




var HorizontalRoadmapStep = function(param) {
    var current = param.current;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        spacing: 2,
        direction: "row",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                sx: {
                    background: current ? _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK : _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[900] */ .w2[900],
                    borderRadius: "64px",
                    minWidth: 16,
                    width: 16,
                    height: 16
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                sx: {
                    background: current ? _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK : _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[900] */ .w2[900],
                    height: 4,
                    width: "100%",
                    borderRadius: "8px"
                }
            })
        ]
    });
};
var HighlightablePanel = function(param) {
    var panelTitle = param.panelTitle, children = param.children, highlight = param.highlight;
    var decorationColor = function decorationColor() {
        switch(highlight){
            case "completed":
                return [
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[700] */ .w2[700],
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[700] */ .w2[700]
                ];
            case "current":
                return [
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK,
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK
                ];
            case "upcoming":
                return [
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK,
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[700] */ .w2[700]
                ];
        }
    };
    var decorationBg = decorationColor();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        direction: "column",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                alignItems: "center",
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        sx: {
                            background: decorationBg[0],
                            borderRadius: "64px",
                            minWidth: 16,
                            width: 16,
                            height: 16
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "label2",
                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[400] */ .w2[400],
                        children: panelTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                pl: 0.75,
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        sx: {
                            background: decorationBg[1],
                            minWidth: 4,
                            maxWidth: 4,
                            width: "100%",
                            borderRadius: "8px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        spacing: 2,
                        children: children
                    })
                ]
            })
        ]
    });
};
var VerticalRoadmapPanel = function(param) {
    var stepTitle = param.stepTitle, subtitle = param.subtitle, subtitleVariant = param.subtitleVariant, children = param.children, highlight = param.highlight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HighlightablePanel, {
        highlight: highlight,
        panelTitle: stepTitle,
        children: [
            subtitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: subtitleVariant ? subtitleVariant : "h4",
                children: subtitle
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                width: {
                    xs: "100%",
                    sm: "60%"
                },
                variant: "body1",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[400] */ .w2[400],
                children: children
            })
        ]
    });
};
var ProcessPanel = function(param) {
    var stepTitle = param.stepTitle, description = param.description, duration = param.duration, children = param.children, highlight = param.highlight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HighlightablePanel, {
        highlight: highlight,
        panelTitle: stepTitle,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "h6",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "body2",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[400] */ .w2[400],
                children: [
                    " ",
                    "Duration: ",
                    typeof duration === "string" ? duration : "~".concat(duration, " days")
                ]
            }),
            children
        ]
    });
};
var RoadmapPanel = function(param) {
    var current = param.current, quarterDescription = param.quarterDescription, quarterText = param.quarterText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HorizontalRoadmapStep, {
                current: current
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "label1",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[400] */ .w2[400],
                children: quarterText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "body2",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[100] */ .w2[100],
                children: quarterDescription
            })
        ]
    });
};


/***/ }),

/***/ 41394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FadeContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99226);

var FadeContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
    var visible = param.visible, time = param.time;
    return {
        opacity: visible ? 1 : 0,
        transition: "opacity ".concat(time, "s ease")
    };
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8844,6888,9774,2888,179], function() { return __webpack_exec__(1822); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);